import React, { useEffect, useMemo, useContext, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Status } from '../../store/ducks/who_we_are/types';
import { teamSelector } from 'store/ducks/who_we_are/selectors/teamSelector';
import { domain, Context } from '../../config';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getTeam } from '../../store/ducks/who_we_are/actions';
import { WhoWeAreAnimation } from '../../components/animations';

const Home = () => {
    const { siteDomain, locale } = useContext(Context);
    const startText = useRef();
    const dispatch = useDispatch();
    const team = useSelector(teamSelector);
    const { status } = useSelector(
        (state: {
            teamReducer: {
                status: Status;
            };
        }) => state.teamReducer
    );

    useEffect(() => {
        if (status === 'IDLE') {
            dispatch(getTeam(locale));
        }
    }, []);

    useEffect(() => {
        setTimeout(() => {
            startText.current.classList.add('_active');
        }, 100);
    }, []);

    return (
        <>
            <Helmet>
                <title>{team.title}</title>
                <meta property="og:title" content={`${team.title}`} />
                <meta property="twitter:title" content={`${team.title}`} />
                <meta name="description" content={`${team.description}`} />
                <meta
                    property="og:description"
                    content={`${team.description}`}
                />
                <meta
                    property="twitter:description"
                    content={`${team.description}`}
                />
                <meta
                    property="og:image"
                    content={`${siteDomain}/img/overbest_og_en.png`}
                />
                <meta property="og:url" content={`${siteDomain}/who_we_are`} />
                <meta name="twitter:card" content="summary_large_image" />
            </Helmet>

            <main className="page-who-we-are">
                <WhoWeAreAnimation />
                <section className="first-screen page-who-we-are__first-screen">
                    <div className="first-screen__container" ref={startText}>
                        <h1 className="first-screen__title title title--white">
                            {team.title}
                        </h1>
                        <p
                            className="first-screen__text text text--white"
                            style={{ whiteSpace: 'pre-line' }}
                            dangerouslySetInnerHTML={{
                                __html: team.description,
                            }}
                        />
                    </div>
                </section>
                <section className="team page-who-we-are__team">
                    <div className="team__container">
                        <h2 className="team__title title title--white">
                            {team.teamTitle}
                        </h2>
                        {team.teamList && team.teamList.length > 0 && (
                            <ul className="team__list">
                                {team.teamList.map(item => (
                                    <li className="team__item" key={item.id}>
                                        <div className="team__col">
                                            <div className="team__img">
                                                {item.Photo &&
                                                    item.Photo.data && (
                                                        <img
                                                            src={
                                                                domain +
                                                                item.Photo.data
                                                                    .attributes
                                                                    .url
                                                            }
                                                            alt="img"
                                                        />
                                                    )}
                                            </div>
                                        </div>
                                        <div className="team__col">
                                            <h3 className="team__name smallTitle smallTitle--white">
                                                {item.Name}
                                            </h3>
                                            <span className="team__position text text--white">
                                                {item.Position}
                                            </span>
                                            <p className="team__text text--white">
                                                {item.Description}
                                            </p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                </section>
                {team.bottomInfo && (
                    <section className="join page-who-we-are__join">
                        <div className="join__container">
                            <h2
                                className="join__title title title--white"
                                dangerouslySetInnerHTML={{
                                    __html: team.bottomInfo.Title,
                                }}
                            />
                            <Link
                                to={team.bottomInfo.LinkUrl}
                                className="join__btn button"
                            >
                                {team.bottomInfo.LinkCaption}
                            </Link>
                        </div>
                    </section>
                )}
            </main>
        </>
    );
};

export default Home;
